import { render, staticRenderFns } from "./checkbox-tree.vue?vue&type=template&id=8458b3c0"
import script from "./checkbox-tree.vue?vue&type=script&lang=js"
export * from "./checkbox-tree.vue?vue&type=script&lang=js"
import style0 from "./checkbox-tree.vue?vue&type=style&index=0&id=8458b3c0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports